// The client is expected to handle the following status codes of the response:
// - `OK` -> Success Message
// - `Not Found` or `Invalid Argument` -> Invalid/Missing Ticket or Order ID
// - `Already Exists` -> Form has already been submitted
// - Other -> Technical Difficulties
export const FormService_DeclarationOfLossFormLazy = () =>
  import("./service.grpc").then((m) => m.FormService_DeclarationOfLossForm);
FormService_DeclarationOfLossFormLazy.method =
  "aysa_api.services.form.v1.FormService/DeclarationOfLossForm" as const;
